import { render, staticRenderFns } from "./creatComment.vue?vue&type=template&id=24e2766f&scoped=true"
import script from "./creatComment.vue?vue&type=script&lang=js"
export * from "./creatComment.vue?vue&type=script&lang=js"
import style0 from "./creatComment.vue?vue&type=style&index=0&id=24e2766f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2766f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e2766f')) {
      api.createRecord('24e2766f', component.options)
    } else {
      api.reload('24e2766f', component.options)
    }
    module.hot.accept("./creatComment.vue?vue&type=template&id=24e2766f&scoped=true", function () {
      api.rerender('24e2766f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/storeComment/creatComment.vue"
export default component.exports